<app-menu class="menuApp"></app-menu>
<div class="main">
  <div class="row first homeRow">

    <div class="col-4">
      <div (click)="toUsers()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">people</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.users")}}</h1>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div (click)="toDevices()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">sensors</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.devices")}}</h1>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div (click)="toAlerts()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">warning_amber</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.alerts")}}</h1>
        </div>
      </div>
    </div>

  </div>

  <div class="row homeRow">

    <div class="col-4">
      <div (click)="toReglas()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">schedule</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.rules")}}</h1>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div (click)="toFade()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">settings_suggest</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.fade")}}</h1>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div (click)="toLimits()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">sort</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.limits")}}</h1>
        </div>
      </div>
    </div>

  </div>

  <div class="row homeRow">

    <div class="col-4">
      <div (click)="toOta()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">contactless</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">OTA</h1>
        </div>
      </div>
    </div>

    <div class="col-4">
      <div (click)="toParameters()" class="button centerVert container">
        <div class="row rowIcon">
          <span class="material-icons-outlined marginAuto homeIconSize">tune</span>
        </div>
        <div class="row rowName">
          <h1 class="text-center marginAuto textXXM">{{this.localiser.get("menu.parameters")}}</h1>
        </div>
      </div>
    </div>

  </div>

</div>
